export class AuthenticateUser {
  Email: string;
  Password: string;
  Tenant: number | null;
  CaptchaCode: string | null;
  CaptchaKey: string | null;
}